import { addMinutes, isBefore } from 'date-fns'
import { TLatestSchedule } from '../store/managePost/newTypes'
import { SETTING_NAME } from '../store/project/types'
import { POST_SOCIAL_STATUS, POST_STATUS, POST_TYPE, SOCIAL_NETWORK } from './post'
import Roles from './roles'

export const APPROVED = 'approved'

export const definePostSocialStatus = (status: POST_STATUS | POST_SOCIAL_STATUS, role?: string) => {
  switch (status) {
    case POST_SOCIAL_STATUS.STATUS_PENDING_INTERNAL_APPROVAL:
      return POST_STATUS.STATUS_PENDING_APPROVAL
    case POST_SOCIAL_STATUS.STATUS_PENDING_EXTERNAL_APPROVAL:
      if (role === Roles.AGENCY_ADMIN || role === Roles.INTERNAL_APPROVER) {
        return APPROVED
      } else {
        return POST_STATUS.STATUS_PENDING_APPROVAL
      }
    case POST_SOCIAL_STATUS.STATUS_PENDING_PUBLISH:
      return APPROVED
    case POST_SOCIAL_STATUS.STATUS_SCHEDULED:
      return APPROVED
    case POST_SOCIAL_STATUS.STATUS_LIVE:
      return APPROVED
    case POST_SOCIAL_STATUS.STATUS_ON_PUBLISHING:
      return APPROVED
  }
  return status
}

export const isShowSocialPostForExternal = (
  status: POST_STATUS | POST_SOCIAL_STATUS,
  role?: string
) => {
  return (
    status &&
    (role !== Roles.EXTERNAL_APPROVER ||
      !(
        status === POST_STATUS.STATUS_TEMPORARY_DRAFT ||
        status === POST_SOCIAL_STATUS.STATUS_PENDING_INTERNAL_APPROVAL ||
        status === POST_STATUS.STATUS_DRAFT
      ))
  )
}

export const defineisEditablePostSocial = ({
  post: { approvals, status },
  postApprovalPlan: {
    approval_plan: { rounds }
  }
}: any) => {
  let isEditable = true
  for (let type of Object.keys(rounds)) {
    approvals.map((approval: any) => {
      if (approval.type === type && approval.is_approved) isEditable = false
    })
  }

  return isEditable
}

export const defineAvailablePostsActions = {
  sendToApprove: (status: POST_STATUS, schedule: TLatestSchedule) => {
    const { date, time } = schedule
    let scheduleDate = date && time ? new Date(`${schedule.date}T${schedule.time}`) : new Date()

    const scheduleIsAfter = isBefore(new Date(), addMinutes(scheduleDate, 15))

    return status === POST_STATUS.STATUS_DRAFT && scheduleIsAfter
  },
  autoposting: (postType: POST_TYPE, selectedSocials: SOCIAL_NETWORK[]) => {
    return (
      (postType === POST_TYPE.POST_TYPE_PHOTO_STORY ||
        postType === POST_TYPE.POST_TYPE_VIDEO_STORY ||
        postType === POST_TYPE.POST_TYPE_MEDIA_CAROUSEL) &&
      selectedSocials.includes(SOCIAL_NETWORK.INSTAGRAM_SOCIAL)
    )
  },
  publishByAdmin: (status: POST_STATUS, role: Roles | undefined) =>
    (role === Roles.AGENCY_ADMIN || role === Roles.SUPER_ADMIN) &&
    !(
      status === POST_STATUS.STATUS_LIVE ||
      status === POST_STATUS.STATUS_DELETED ||
      status === POST_STATUS.STATUS_ON_PUBLISHING
    ),
  publishByContentManager: (status: POST_STATUS) =>
    !(
      status === POST_STATUS.STATUS_LIVE ||
      status === POST_STATUS.STATUS_DELETED ||
      status === POST_STATUS.STATUS_ON_PUBLISHING
    ),
  publishNow: (status: POST_STATUS) =>
    status === POST_STATUS.STATUS_SCHEDULED ||
    status === POST_STATUS.STATUS_PENDING_PUBLISH ||
    status === POST_STATUS.STATUS_PUBLISHING_FAILED,
  scheduleAndSkipApproval: (status: POST_STATUS) =>
    status !== POST_STATUS.STATUS_SCHEDULED &&
    status !== POST_STATUS.STATUS_LIVE &&
    status !== POST_STATUS.STATUS_ON_PUBLISHING &&
    status !== POST_STATUS.STATUS_DELETED,
  batchApprove: function () {},
  updatePostSocials: (status: POST_STATUS) =>
    status === POST_STATUS.STATUS_DRAFT ||
    status === POST_STATUS.STATUS_REQUIRES_REVISION ||
    status === POST_STATUS.STATUS_PENDING_APPROVAL ||
    status === POST_STATUS.STATUS_SCHEDULED ||
    status === POST_STATUS.STATUS_PENDING_PUBLISH,
  schedule: (status: POST_STATUS) =>
    status !== POST_STATUS.STATUS_LIVE &&
    status !== POST_STATUS.STATUS_ON_PUBLISHING &&
    status !== POST_STATUS.STATUS_DELETED,
  copyContentToOtherSM: (status: POST_STATUS) =>
    status === POST_STATUS.STATUS_DRAFT ||
    status == POST_STATUS.STATUS_SCHEDULED ||
    status == POST_STATUS.STATUS_PENDING_APPROVAL ||
    status === POST_STATUS.STATUS_REQUIRES_REVISION ||
    status === POST_STATUS.STATUS_PENDING_PUBLISH ||
    status === POST_STATUS.STATUS_TEMPORARY_DRAFT,

  duplicate: true
}
